<template>
  <div>
    <div class="upload-container">
      <!-- 文件显示 -->
      <div class="file-analysis">
        <!--文件类型图标-->
        <mtd-row>
          <mtd-col :span="24">
            <div class="file-type-container">
              <div class="file-type-icon">
                <img :src="require('@/assets/'+pictureSelect+'.png')" style="width: 100%;height: 100%">
              </div>
            </div>
          </mtd-col>
        </mtd-row>
        <!-- 文件名称和状态-->
        <mtd-row>
          <mtd-col :span="24">
            <div class="file-name-container">
              <span>{{ fileName }}&nbsp;</span>
            </div>
            <div class="file-status-container">
              <span>{{ fileStatus }}</span>
              <mtd-icon name='success-circle' v-if="success" class="status-icon success-icon"></mtd-icon>
              <mtd-icon name='error-circle' v-if="error" class="status-icon error-icon"></mtd-icon>
            </div>
          </mtd-col>
        </mtd-row>
        <!-- 进度条-->
        <mtd-row style="margin-top: 25px">
          <mtd-col :span="24">
            <div class="progress-status-container">
              <div class="scroll-div" :class="{'moving-animation' : analysing}" v-if="analysing"></div>
              <div class="scroll-success" v-if="success"></div>
              <div class="scroll-error" v-if="error"></div>
            </div>
          </mtd-col>
        </mtd-row>
      </div>
      <!-- 有效期设置 -->
      <div class="validate-days-container" @click="open_validate_select" v-if="!current_refuse_send_out">
        <span style="color: rgba(10,112,245,1);">{{ validateDays }}</span>天有效期
      </div>
      <!-- 完善信息 -->
      <div class="email-container" v-if="!current_refuse_send_out">
        <mtd-form>
          <div class="extra-info">
            <div class="email-title"><span>完善信息</span></div>
            <div class="underline-div" style="margin-bottom: 0"></div>
            <mtd-form-item class="strategy-select" label="审批流程" :label-width="70" v-if="extraInfo">
              <div @click="strategySelectShow = true" class="select-div">
                <mtd-row>
                  <mtd-col :span="22" style="text-align: right"><span class="strategy-name">{{
                      submit_param.strategyName
                    }}</span>
                  </mtd-col>
                  <mtd-col style="font-size: 20px;" :span="2">
                    <mtd-icon name="right-thick"></mtd-icon>
                  </mtd-col>
                </mtd-row>
              </div>
            </mtd-form-item>
            <mtd-form-item class="reason-input" label="申请原因" prop="reason" :label-width="70">
              <mtd-textarea placeholder="请详细输入申请原因" class="reason-input-area"
                            v-model="submit_param.fileOutReason" style="width: 100%;"
                            rows="3" maxlength="50"/>
            </mtd-form-item>
          </div>
          <mtd-row>
            <mtd-col :span="24" class="email-title">
              <mtd-checkbox v-model="email_auto_collapse" @input="email_collapse_change()">
                <span class="dd-page-subtitle">收件人邮箱(选填)</span>
              </mtd-checkbox>
            </mtd-col>
          </mtd-row>
          <mtd-row v-if="email_auto_collapse">
            <mtd-col :span="24">
              <div class="underline-div"></div>
              <mtd-form-item helper="审批通过后，文件下载的链接将自动发送到填写的邮箱" :label-width="0">
                <div class="el-email">
                  <el-select
                    v-model="emails"
                    multiple
                    :no-data-text="noDataText"
                    filterable @change="triggerSelect"
                    :popper-class="popper_class"
                    allow-create class="email-input"
                    default-first-option
                    placeholder="请输入并选择邮箱"></el-select>
                </div>
              </mtd-form-item>
            </mtd-col>
          </mtd-row>
        </mtd-form>
      </div>
      <div class="email-container" v-if="current_refuse_send_out">
        <div class="extra-info">
          <mtd-row>
            <mtd-col style="text-align: center; color: rgba(255,0,0,0.69)">
              <div><i class="mtdicon-error-circle" style="font-size: 32px"></i></div>
              <div class="dd-page-subtitle" style="margin-top: 10px;">命中部门禁止外发策略。</div>
              <div class="dd-page-subtitle">如有疑问请联系{{ templateContactPerson }}</div>
            </mtd-col>
          </mtd-row>
        </div>
      </div>
      <!-- 提交 -->
      <div class="btn-container">
        <mtd-button class="btn-demo-item" style="width: 164px" :disabled="submit_disabled" type="primary"
                    size="large" @click="submit" :loading="submitLoading">申请外发
        </mtd-button>
      </div>
    </div>

    <mtdm-actionsheet v-model="strategySelectShow" title="请选择审批流程" :options="strategies" @select="confirmStrategy"/>

    <!-- 选择有效期 -->
    <mtdm-slide-modal v-model="validate_days_modal" title="设置有效期">
      <div class="validate_days_content">
        <mtd-radio-group v-model="validateDays" @input="validateDays_change">
          <mtd-radio :value="3" @click="validateDays_click">3天</mtd-radio>
          <mtd-radio :value="7" @click="validateDays_click">7天</mtd-radio>
          <mtd-radio :value="30" @click="validateDays_click">30天</mtd-radio>
          <mtd-radio :value="-1">
            <span>自定义到期日</span><br/>
            <span class="custom-tips">可设定30天内任意日期</span>
          </mtd-radio>
        </mtd-radio-group>
      </div>
    </mtdm-slide-modal>
    <!-- 自定义有效期 -->
    <mtdm-scrollpicker v-model="custom_validate_modal" :options="select_number" :value="custom_validate_days"
                       @cancel="close_custom_validate" @confirm="submit_custom_validate"
                       confirm-text="确定" nodeKey="value"/>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "mobile_file_upload",
  data() {
    const validateCustomDays = (_rule, value, callback) => {
      if (!/^[0-9]*$/.test(value)) {
        return callback(new Error('最长有效期为30天，请输入1-30以内的数字'));
      }
      if (value < 1 || value > 30) {
        return callback(new Error('最长有效期为30天，请输入1-30以内的数字'));
      }
      return callback();
    }
    return {
      default_days: [
        {value: 3, label: '3天'},
        {value: 7, label: '7天'},
        {value: 30, label: '30天'}
      ],
      fileXmId: '',
      fileName: '测试文档.xlsx',
      strings: '',
      progressPercentage: 33,
      progressStatus: '',
      analysing: true,
      success: false,
      error: false,
      extraInfo: false,
      submit_param: {
        emails: '',
        strategyName: '请选择策略',
        fileOutReason: '',
        files: [],
        id: -1
      },
      reason: '',
      strategySelectShow: false,
      strategyName: '',
      reasonInputFlag: false,
      againFlag: false,
      submitFlag: false,
      emails: [],
      strategies: [],
      submitLoading: false,
      email_list: [],
      popper_class: 'select_hide',
      validateDays: 3,
      validate_days_modal: false,
      custom_validate_days: [3],
      custom_validate_modal: false,
      custom_validate_rule: {
        custom_validate: [
          {validator: validateCustomDays, trigger: 'change'},
        ]
      },
      email_auto_collapse: null,
      current_refuse_send_out: false,
      current_refuse_send_file_list: [],
      templateContactPerson: "员工帮助台"
    }
  },
  computed: {
    select_number() {
      let result = []
      for (let i = 1; i <= 30; i++) {
        result.push({label: i, value: i});
      }
      return result;
    },
    fileStatus() {
      if (this.current_refuse_send_out) {
        return '拒绝外发';
      }
      if (this.success) {
        return '分析成功';
      } else if (this.error) {
        return '分析失败';
      } else if (this.analysing) {
        return '分析中…';
      }
    },
    noDataText() {
      if (this.emails.length > 0) {
        return '若仍有需要发送的邮件，请继续输入';
      } else {
        return '请先输入并选择邮箱'
      }
    },
    submit_disabled() {
      if (!this.success) {
        return true;
      }
      if (this.submitFlag) {
        return true;
      }
      if (this.extraInfo) {
        console.log("附加信息有值");
        if (!this.submit_param.fileOutReason || this.submit_param.fileOutReason === '') {
          return true;
        }
      }
      if (this.current_refuse_send_out && this.current_refuse_send_file_list && this.current_refuse_send_file_list.length > 0) {
        return true;
      }
      return false;
    },
    pictureSelect() {
      let temp = this.fileName.split('.');
      let fileType = temp[temp.length - 1].toLowerCase();
      switch (fileType) {
        // 表格
        case 'xlsx':
        case 'xls':
          return 'excel';
        // word
        case 'doc':
        case 'docx':
          return 'word';
        // 压缩包
        case 'zip':
          return 'zip';
        // ppt
        case 'ppt':
        case 'pptx':
          return 'ppt';
        // pdf
        case 'pdf':
          return 'pdf';
        // 视频
        case 'avi':
        case 'mpg':
        case 'wmv':
        case 'mov':
        case 'mp4':
          return 'video';
        // 音频
        case 'mp3':
        case 'wma':
          return 'music';
        // 图片
        case 'png':
        case 'gif':
        case 'jpg':
        case 'jpeg':
          return 'picture';
        // 图片素材
        case 'psd':
          return 'PS';
        // 图片素材
        case 'sketch':
          return 'sketch';
        // numbers
        case 'numbers':
          return 'numbers';
        // keynote
        case 'keynote':
          return 'keynote';
        // ai
        case 'ai':
          return 'AI';
        default:
          return 'usual'
      }
    }
  },
  mounted() {
    // 修改标题
    document.title = "发送给外部人员";
    this.fileXmId = this.$route.query.fileXmId;
    this.fileName = this.$route.query.fileName;
    this.againFlag = this.$route.query.againFlag;
    if (this.fileXmId === '' || this.fileName === '') {
      this.$mtdm.toast({
        message: '获取文件信息失败',
        icon: 'mtdmicon-error-circle',
        duration: 2000
      });
      this.$router.push({name: 'mobile_file|404'});
      return;
    }
    if (this.fileName.indexOf(".") === -1) {
      this.analysing = false;
      this.error = true;
      this.$mtdm.toast({
        message: '不支持的文件类型',
        icon: 'mtdmicon-error-circle',
        duration: 2000
      });
      return;
    }
    // 判断当前文件是否存在外发记录
    this.scan();
  },
  methods: {
    ...mapActions([
      'xmFileOutGoing',
      'submitFileOutOrder',
      'submitFileOutOrderExemption',
      'queryApprovalDetails'
    ]),
    triggerSelect() {
      this.popper_class = 'select_hide';
    },
    email_collapse_change() {
      if (this.email_auto_collapse) {
        setTimeout(() => {
          this.hideSelect();
        }, 500);
      }
    },
    // 监听事件
    hideSelect() {
      let div_ele = document.getElementsByClassName("email-input")[0];
      let input_ele = div_ele.getElementsByClassName("el-select__input")[0];

      input_ele.addEventListener('input', () => {
        let v = input_ele.value;
        if (v && v !== '') {
          this.popper_class = 'select_show';
        } else {
          this.popper_class = 'select_hide';
        }
      });
    },
    // 提交外发申请
    submit() {
      this.submitLoading = true;
      let param = this.submit_param;
      param.strings = this.strings;
      param.fileXmId = this.fileXmId;
      param.emails = this.emails.join(",");
      param.validateDays = this.validateDays;

      let isExemption;
      if (this.strategies == null || this.strategies.length === 0) {
        isExemption = true;
      } else {
        isExemption = this.strategies.find(item => {
          return item.value === param.id
        }).isExemption;
      }
      if (!isExemption) {
        this.submitFileOutOrder(param).then(res => {
          if (res.code === 0) {
            this.$mtdm.toast({
              message: '已提交申请',
              icon: 'mtdmicon-success-circle',
              duration: 2000
            });
            this.submitFlag = true;
            this.check_process(res.data.recordId);
          } else {
            this.$mtdm.toast({
              message: '提交失败',
              icon: 'mtdmicon-error-circle',
              duration: 2000
            });
          }
        }).finally(() => {
          this.submitLoading = false;
        });
      } else {
        this.submitFileOutOrderExemption(param).then(res => {
          if (res.code === 0) {
            this.$mtdm.toast({
              message: '已提交申请',
              icon: 'mtdmicon-success-circle',
              duration: 2000
            });
            this.submitFlag = true;
            this.check_process(res.data.recordId);
          } else {
            this.$mtdm.toast({
              message: '提交失败',
              icon: 'mtdmicon-error-circle',
              duration: 2000
            });
          }
        }).finally(() => {
          this.submitLoading = false;
        });
      }
    },
    check_process(index) {
      this.queryApprovalDetails({id: index}).then(res => {
        if (res.code === 0) {
          this.$router.push({
            name: 'mobile_file|outer|file_out_progress',
            params: {record: res.data, approvalList: res.approvalList}
          });
        } else {
          this.$mtdm.toast({
            message: '查询失败',
            icon: 'mtdmicon-error-circle',
            duration: 2000
          });
        }
      });
    },
    // 分析文件特征和策略
    async scan() {
      let param = {fileXmId: this.fileXmId, fileName: this.fileName, againFlag: this.againFlag};
      await this.xmFileOutGoing(param).then(res => {
        if (res.code === 0) {
          if (res.data.hasOwnProperty('files')) {
            let strategies = [];
            if (res.data.results != null) {
              strategies = res.data.results;
            }
            for (let i = 0; i < strategies.length; i++) {
              this.strategies.push({
                label: strategies[i].strategyName,
                value: strategies[i].id,
                isExemption: strategies[i].isExemption,
                needsFileOutReason: strategies[i].needsFileOutReason
              });
            }
            if (this.strategies && this.strategies.length > 0) {
              let selectItem = this.strategies[0];
              this.submit_param.strategyName = selectItem.label;
              this.submit_param.id = selectItem.value;
            }
            this.submit_param.files = res.data.files;
            this.strings = res.data.strings;
            this.analysing = false;
            this.success = true;
            if (this.strategies != null && this.strategies.length !== 0) {
              this.extraInfo = true;
            } else {
              this.strategies = [];
            }
            // 添加拒绝外发的配置
            let {refuseSendOut, hitFileIdList, templateContactPerson} = res.data;
            if (templateContactPerson && templateContactPerson !== '') {
              this.templateContactPerson = templateContactPerson;
            }
            if (refuseSendOut && hitFileIdList && hitFileIdList.length > 0) {
              this.current_refuse_send_out = true;
              this.current_refuse_send_file_list = hitFileIdList;
              this.success = false;
              this.error = true;
            } else {
              this.current_refuse_send_out = false;
              this.current_refuse_send_file_list = [];
            }
          } else {
            this.$router.push({
              name: 'mobile_file|outer|file_out_progress',
              params: {record: res.data, approvalList: res.approvalList}
            });
          }
        }
      }).catch(_e => {
        this.analysing = false;
        this.error = true;
        this.$mtdm.toast({
          message: '分析文件失败',
          icon: 'mtdmicon-error-circle',
          duration: 3000
        });
      });
    },
    cancel() {
      // 点击次要按钮，触发该事件
      this.reasonInputFlag = false;
      this.reason = '';
      return false;
    },
    confirm() {
      // 点击主要按钮，触发该事件
      this.submit_param.fileOutReason = this.reason;
      this.reason = '';
      this.reasonInputFlag = false;
      return false;
    },
    confirmStrategy(item) {
      this.submit_param.strategyName = item.label;
      this.submit_param.id = item.value;
    },
    open_validate_select() {
      this.validate_days_modal = true;
    },
    validateDays_change(val) {
      if (val === -1) {
        this.custom_validate_modal = true;
      } else {
        this.custom_validate_modal = false;
        this.validate_days_modal = false;
      }
    },
    validateDays_click() {
      if (this.validateDays !== -1) {
        this.custom_validate_modal = false;
        this.validate_days_modal = false;
      }
    },
    close_custom_validate() {
      this.custom_validate_modal = false;
      this.custom_validate_days = [3];
      this.validateDays = 3;
    },
    submit_custom_validate(values) {
      if (values.length === 0) {
        return;
      }
      this.validateDays = values[0];
      this.custom_validate_modal = false;
      this.validate_days_modal = false;
      this.custom_validate_days = [3];
    }
  }
}
</script>

<style>
/*文件分析部分*/
.upload-container {
  background-color: #f7f7f7;
  padding: 8px;
  min-height: 100vh;
}

.file-analysis {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  min-height: 234px;
  margin-bottom: 8px;
  padding: 32px;
}

.file-type-container {
  margin: auto;
  padding: 16px;
  border-radius: 4px;
  background: rgba(247, 247, 247, 1);
  width: 72px;
  height: 72px;
}

.file-type-icon {
  width: 40px;
  height: 40px;
}

.file-name-container {
  margin-top: 12px;
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.36);
  letter-spacing: 0;
  text-align: center;
  line-height: 22px;
  font-weight: 500;
}

.file-status-container {
  margin-top: 16px;
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.84);
  letter-spacing: 0;
  text-align: center;
  line-height: 22px;
  font-weight: 500;
}

.progress-status-container {
  width: 100%;
  height: 4px;
  background-color: rgba(0, 0, 0, .06);
  border-radius: 2px;
}

.scroll-div {
  background-color: #0A70F5;
  width: 33%;
  height: 100%;
  border-radius: 2px;
}

.scroll-success {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background-color: #48CA51;
}

.scroll-error {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background-color: #f5483b;
}

.status-icon {
  margin-left: 3px;

  font-size: 24px;
  vertical-align: middle;
}

.success-icon {
  color: #00B365;
}

.error-icon {
  color: #f5483b;
}

.moving-animation {
  animation: move 2s infinite;
}

/*循环滚动动画*/
@-webkit-keyframes move {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(204%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes move {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(204%);
  }
  100% {
    transform: translateX(0);
  }
}

/* 有效期选择 */
.validate-days-container {
  width: 100%;
  background-color: white;
  padding: 16px 22px;
  border-radius: 10px;
  transform: translateX(0);
  margin-bottom: 8px;
  cursor: pointer;
}

.validate-days-container span:after {
  content: '';
  position: absolute;
  right: 12px;
  display: block;
  top: 50%;
  width: 8px;
  height: 8px;
  -webkit-transform: translateY(-75%) rotate(-45deg);
  transform: translateY(-75%) rotate(-45deg);
  border-right: 1px solid #b2b2b2;
  border-bottom: 1px solid #b2b2b2;
  -webkit-transform-origin: 75% 75%;
  transform-origin: 75% 75%;
  -webkit-transition-duration: .3s;
  transition-duration: .3s;
}

/*邮箱部分*/
.email-container {
  width: 100%;
  background-color: white;
  padding: 16px 22px;
  border-radius: 10px;
  transform: translateX(0);
}

.email-title {
  font-family: PingFang SC, sans-serif;
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  line-height: 21px
}

.underline-div {
  margin-top: 16px;
  margin-bottom: 10px;
  height: 1px;
  width: 100%;
  background-color: #f7f7f7;
}

.email-input .mtd-input {
  border: none;
  padding-right: 0;
  padding-left: 0;
  font-family: PingFang SC, sans-serif;
  font-size: 17px;
  color: rgba(0, 0, 0, 1);
  font-weight: 400;
  line-height: 24px;
}

.el-select .el-input__inner {
  border: none;
  padding-left: 0;
}

.el-select .el-select__input {
  margin-left: 0;
}

.email-input {
  width: 100%;
  border: none;
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 17px;
  color: rgba(0, 0, 0, 0.24);
  font-weight: 400;
  line-height: 24px
}

.btn-container {
  text-align: center;
  margin-top: 36px;
}

.select-div {
  height: 24px;
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.24);
  line-height: 22px;
  font-weight: 400;
}

.strategy-name {
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
  letter-spacing: 0;
  text-align: right;
  line-height: 22px;
  font-weight: 400;
}

.strategy-select {
  padding: 16px 0;
  height: 56px;
  border-bottom: 1px #f7f7f7 solid;
}

.strategy-select .mtd-form-item-label, .reason-input .mtd-form-item-label {
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.84);
  letter-spacing: 0;
  text-align: left;
  line-height: 22px;
  font-weight: 400;
  margin-bottom: 0;
}

.reason-input {
  padding: 16px 0;
  border-bottom: 1px #f7f7f7 solid;
  margin-bottom: 16px;
}

.reason-input .mtd-form-item-content {
  line-height: 22px;
}

.reason-input-area {
  border: none;
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
  line-height: 22px;
  font-weight: 400;
  padding: 0 5px;
  margin-top: 0;
}

.email-input .mtd-select-multiple .mtd-select-input {
  padding-left: 16px;
}

.email-input .mtd-form-item-helper {
  padding-left: 12px;
}

.email-input .mtd-select-tags {
  padding-left: 0;
}

.email-input .mtd-select-search-field {
  margin: 0;
}

div.select_hide {
  display: none !important;
}

div.select_show {
  display: inline-block !important;
}

.email-input .mtd-select-search-field {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 17px;
  color: rgba(0, 0, 0, 1);
  font-weight: 400;
  line-height: 24px
}

.validate_days_content {
  padding: 14px 16px;
  height: 270px;
}

.validate_days_content .mtd-radio {
  display: block;
  width: 100%;
  height: 22px;
  margin-bottom: 28px;
}

.validate_days_content .mtd-radio .custom-tips {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.36);
  letter-spacing: 0;
  font-weight: 400;
  line-height: 17px;
  margin-left: 24px;
}

.dd-page-subtitle {
  font-family: PingFangSC-Medium, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 22px;
  font-weight: 500;
}
</style>
